import { Box } from '@material-ui/core';
import { formatPercent } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface MetricVariationProps {
  variation: number | undefined;
  previous?: string | number;
}

export const MetricVariation = ({ variation, previous = undefined }: MetricVariationProps) => {
  const { palette, customBorderRadius } = useCustomTheme();

  return (
    <>
      <Box
        gridGap={4}
        display={'flex'}
        alignItems={'center'}
        width={'fit-content'}
        style={{
          padding: '1px 6px',
          borderRadius: customBorderRadius.paper / 2,
          color: !variation ? palette.grey[400] : variation < 0 ? palette.error.main : palette.success.main,
          backgroundColor: !variation ? palette.grey[100] : variation < 0 ? palette.error.light : palette.success.light,
        }}
      >
        {variation ? <Icon size={16}>{variation < 0 ? 'trending_down' : 'trending_up'}</Icon> : <></>}
        {variation === undefined ? '-' : formatPercent(variation, 1, true)}
      </Box>
      {previous && (
        <Font variant="caption" color="textSecondary">
          <Text tId={'OF_PREV_PERIOD'} dynamicDataTexts={[previous]} />
        </Font>
      )}
    </>
  );
};

const rgba = (hex: string, alpha: number) => {
  const [r, g, b] = hex.match(/\w\w/g)?.map((x) => parseInt(x, 16)) ?? [];
  return `rgba(${r},${g},${b},${alpha})`;
};
